/*
  Back/Forward Cache is the feature from browsers that save the
  last/next page the user visited to avoid reloading when they
  navigate their browsing history.

  Sometimes though, the cache gets stale (like if they did some
  data change that should be reflected in the last page once they
  hit the back button).

  These utilities are meant to handle those scenarios by allowing
  actions to trigger expireBFCache(), signaling that the cache is
  now stale. Then pages that care about it can define their own
  rules of reloading.

  --- How to enable Back/Forward Browser Cache in dev for debugging ---

  It's quite hackish but it's the only way I found (besides running the entire
  app in production mode). We effectively disable the websocket connection
  that Vite uses to communicate with the dev server since websockets prevent
  the BF cache behavior.

  Step-by-step:

    > dev exec vite bash
    > apt-get install neovim
    > nvim node_modules/vite/dist/client/client.mjs

    - Look for the createConnection function definitions (there are 2)
    - Replace them with something like "false" so they don't actually start a websocket connection

  Now you should be able to simulate the BF Cache in your browser :)
  You can test it in the dev tools "Application" tab, there should be a
  "Back/Forward Cache" item in the Background Services section.

  Remember to re-install the vite dependency afterwards so you restore
  the original behavior in your dev env.
*/

export const onExpiredBFCacheLoad = (reloadFunction: () => void) => {
  window.addEventListener("pageshow", function(event) {
    // event.persisted is true if the page was loaded from the BFCache
    if (event.persisted && isBFCacheExpired()) {
      reloadFunction()
    }
    resetBFCacheFlag()
  });
}

export const expireBFCache = () => sessionStorage.setItem("isBFCacheExpired", "true")
const resetBFCacheFlag = () => sessionStorage.removeItem("isBFCacheExpired")
const isBFCacheExpired = () => !!sessionStorage.getItem("isBFCacheExpired")
